module.exports = __webpack_public_path__ + "img/JalaApp.034cad65.svg";